<template>
  <va-create-layout>
    <manure-storages-form :title="title" :item="item"></manure-storages-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
